import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import remoteServices from '~/constants/RemoteServices';
import {metrics} from '~/vendor/metrics';
import Notification from '~/components/Notification';
import {Button, Stack} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function BuyBlankFromStore(props) {
  useEffect(() => {
    metrics.pageViewTag('/ndx/quote/mask/blank');
  }, []);

  return (
    <Notification {...props} title="Would you like to purchase without design?">
      <Stack className="notification-stack">
        <Button
          size="large"
          className="notification-cta"
          data-testid="buy-blank-from-store"
          href={`${remoteServices.stores}/health-wellness`}
          rel="noopener noreferrer">
          Yes, purchase blank
        </Button>
        <Button
          size="large"
          data-testid="back-to-designing"
          className="notification-cta"
          variant="secondary"
          onClick={props.dismiss}>
          Back To Designing
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  currentColorId: PropTypes.string,
  dismiss: PropTypes.func
};

BuyBlankFromStore.propTypes = propTypes;

BuyBlankFromStore.displayName = 'BuyBlankFromStore';

export default BuyBlankFromStore;
